module.exports = __webpack_public_path__ + "img/user.64fca410.svg";